import { Injectable, Inject, Output, EventEmitter } from '@angular/core';
import { appHttpClient } from '@framework';
import { CallerAddressModel } from '@models';
import { environment as env } from 'environments/environment';

@Injectable()
export class CallerServices {
    
        
    private get _endpoint() { return env.epos_apiURL}

    constructor(@Inject('appHttpClient') private _httpClient: appHttpClient) { }


    FindCallerAddress(_instance?: CallerAddressModel) {
        let _endpoint = this._endpoint + "/addresses/customer";
        if (_instance) { _endpoint += '?' + _instance.toQueryParamData(); }
        return this._httpClient.Get(_endpoint).map(res => res.json());
      }




};
